export enum ContextualMenuContentKeys {
  DEFAULT = 'DEFAULT',
  VECTOR_DEFAULT_POSITON = 'VECTOR_DEFAULT_POSITON',
  VECTOR_DEFAULT_EDIT = 'VECTOR_DEFAULT_EDIT',
  RECTANGLE_DEFAULT_POSITION = 'RECTANGLE_DEFAULT_POSITION',
  RECTANGLE_DEFAULT_EDIT = 'RECTANGLE_DEFAULT_EDIT',
  QR_DEFAULT_POSITION = 'QR_DEFAULT_POSITION',
  QR_DEFAULT_EDIT = 'QR_DEFAULT_EDIT',
  IMAGE_DEFAULT_POSITION = 'IMAGE_DEFAULT_POSITION',
  IMAGE_DEFAULT_EDIT = 'IMAGE_DEFAULT_EDIT',
  TEXT_DEFAULT_POSITION = 'TEXT_DEFAULT_POSITION',
  TEXT_DEFAULT_EDIT = 'TEXT_DEFAULT_EDIT',
  FANCYTEXT_DEFAULT_POSITION = 'FANCYTEXT_DEFAULT_POSITION',
  FANCYTEXT_DEFAULT_EDIT = 'FANCYTEXT_DEFAULT_EDIT',
  VIDEO_DEFAULT_POSITION = 'VIDEO_DEFAULT_POSITION',
  VIDEO_DEFAULT_EDIT = 'VIDEO_DEFAULT_EDIT',
  TABLE_DEFAULT_POSITION = 'TABLE_DEFAULT_POSITION',
  TABLE_DEFAULT_EDIT = 'TABLE_DEFAULT_EDIT',
  MENU_DEFAULT_POSITION = 'MENU_DEFAULT_POSITION',
  MENU_DEFAULT_EDIT = 'MENU_DEFAULT_EDIT',
  SLIDESHOW_DEFAULT_POSITION = 'SLIDESHOW_DEFAULT_POSITION',
  SLIDESHOW_DEFAULT_EDIT = 'SLIDESHOW_DEFAULT_EDIT',
  TABS_DEFAULT_POSITION = 'TABS_DEFAULT_POSITION',
  TABS_DEFAULT_EDIT = 'TABS_DEFAULT_EDIT',
  TRANSCRIPT_DEFAULT_POSITION = 'TRANSCRIPT_DEFAULT_POSITION',
  TRANSCRIPT_DEFAULT_EDIT = 'TRANSCRIPT_DEFAULT_EDIT',
}

export const contextualMenuContentKeyValues = [
  ContextualMenuContentKeys.DEFAULT,
  ContextualMenuContentKeys.VECTOR_DEFAULT_POSITON,
  ContextualMenuContentKeys.VECTOR_DEFAULT_EDIT,
  ContextualMenuContentKeys.RECTANGLE_DEFAULT_POSITION,
  ContextualMenuContentKeys.RECTANGLE_DEFAULT_EDIT,
  ContextualMenuContentKeys.QR_DEFAULT_POSITION,
  ContextualMenuContentKeys.QR_DEFAULT_EDIT,
  ContextualMenuContentKeys.IMAGE_DEFAULT_POSITION,
  ContextualMenuContentKeys.IMAGE_DEFAULT_EDIT,
  ContextualMenuContentKeys.TEXT_DEFAULT_POSITION,
  ContextualMenuContentKeys.TEXT_DEFAULT_EDIT,
  ContextualMenuContentKeys.FANCYTEXT_DEFAULT_POSITION,
  ContextualMenuContentKeys.FANCYTEXT_DEFAULT_EDIT,
  ContextualMenuContentKeys.VIDEO_DEFAULT_POSITION,
  ContextualMenuContentKeys.VIDEO_DEFAULT_EDIT,
  ContextualMenuContentKeys.TABLE_DEFAULT_POSITION,
  ContextualMenuContentKeys.TABLE_DEFAULT_EDIT,
  ContextualMenuContentKeys.MENU_DEFAULT_POSITION,
  ContextualMenuContentKeys.MENU_DEFAULT_EDIT,
  ContextualMenuContentKeys.SLIDESHOW_DEFAULT_POSITION,
  ContextualMenuContentKeys.SLIDESHOW_DEFAULT_EDIT,
  ContextualMenuContentKeys.TABS_DEFAULT_POSITION,
  ContextualMenuContentKeys.TABS_DEFAULT_EDIT,
  ContextualMenuContentKeys.TRANSCRIPT_DEFAULT_POSITION,
  ContextualMenuContentKeys.TRANSCRIPT_DEFAULT_EDIT,
];
